import ReactDOM from 'react-dom';
import { Spin } from 'antd';

export class Loading {
  static show() {
    if (document.getElementById('loading')) {
      return;
    }
    const dom = document.createElement('div');
    dom.setAttribute('id', 'loading');
    document.body.appendChild(dom);
    ReactDOM.render(
      <Spin
        size="large"
        tip="loading..."
      />,
      dom
    );
  }
  static hide() {
    const loading = document.getElementById('loading');
    if (loading) {
      document.body.removeChild(loading);
    }
  }
}
